/** Mirrors `backend/utils/bullionOddsSnapshot.js` — unwrap snapshot jsonb: legacy array or `{ captured_at, markets }`. */

export function bullionOddsSnapshotMarkets(raw: unknown): unknown[] {
    if (!raw) return [];
    if (typeof raw === "string") {
        const s = raw.trim();
        if (!s) return [];
        try {
            return bullionOddsSnapshotMarkets(JSON.parse(s) as unknown);
        } catch {
            return [];
        }
    }
    if (Array.isArray(raw)) return raw;
    if (typeof raw === "object" && raw !== null && Array.isArray((raw as { markets?: unknown }).markets)) {
        return (raw as { markets: unknown[] }).markets;
    }
    return [];
}

export function bullionOddsSnapshotCapturedAt(raw: unknown): string | null {
    if (raw && typeof raw === "object" && !Array.isArray(raw) && (raw as { captured_at?: unknown }).captured_at != null) {
        const s = String((raw as { captured_at: unknown }).captured_at).trim();
        return s || null;
    }
    return null;
}
